/* Krautz Ironz Redesign – ki-theme.js
 * Ported from the delivered theme.js. Runs next to Pursuit's theme.js:
 *  - never touches window.theme / window.routes / window.slate / window.Modals (Pursuit owns them; window.routes is only READ)
 *  - only queries inside `.ki` roots and only via data-ki-* attributes
 *  - exposes window.KI (read-only helpers) for debugging/extensions
 */
(function () {
  'use strict';
  if (window.KI && window.KI.__booted) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- config (from ki-main-product's <script data-ki-config>, else defaults) ---------- */
  function readConfig(scope) {
    var el = $('[data-ki-config]', scope) || $('.ki [data-ki-config]') || $('[data-ki-config]');
    var cfg = {};
    if (el) { try { cfg = JSON.parse(el.textContent); } catch (e) { cfg = {}; } }
    cfg.routes = cfg.routes || {};
    cfg.strings = cfg.strings || {};
    var pr = window.routes || {};
    cfg.routes.cart = cfg.routes.cart || pr.cartUrl || '/cart';
    cfg.routes.cartAdd = cfg.routes.cartAdd || pr.cartAddUrl || '/cart/add';
    cfg.lowStock = cfg.lowStock || 5;
    cfg.moneyFormat = cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    return cfg;
  }
  var CFG = readConfig(document);

  /* ---------- money (shop.money_format) ---------- */
  function money(cents, fmt) {
    fmt = fmt || CFG.moneyFormat;
    var n = cents / 100;
    var map = {
      amount: n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals: Math.round(n).toLocaleString('en-US'),
      amount_with_comma_separator: n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals_with_comma_separator: Math.round(n).toLocaleString('de-DE'),
      amount_with_space_separator: n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_with_period_and_space_separator: n.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals_with_space_separator: Math.round(n).toLocaleString('fr-FR')
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) { return map[k] != null ? map[k] : map.amount; });
  }

  /* ---------- cart: count + Pursuit drawer ---------- */
  function updateCartCount() {
    return fetch(CFG.routes.cart + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-ki-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        return c;
      })
      .catch(function () {});
  }

  /* Opens Pursuit's cart drawer exactly like Pursuit does (theme.Cart.prototype._sidebarDrawerOpen). Returns false if no drawer. */
  function openPursuitDrawer() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return false;
    if (!drawer.classList.contains('show')) {
      drawer.classList.add('show');
      document.body.classList.add('show_overlay');
      drawer.addEventListener('transitionend', function () {
        try {
          drawer.focus();
          if (window.slate && window.slate.a11y && window.slate.a11y.trapFocus) {
            window.slate.a11y.trapFocus({ container: drawer, elementToFocus: drawer });
          }
        } catch (e) {}
      }, { once: true });
    }
    return true;
  }

  /* Re-renders Pursuit's drawer content (GET cart?view=drawer, replace .Cart) and opens it. */
  function refreshAndOpenDrawer() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return Promise.resolve(false);
    var url = ((window.routes && window.routes.cartUrl) || CFG.routes.cart || '/cart') + '?view=drawer&timestamp=' + Date.now();
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('.Cart');
        var current = drawer.querySelector('.Cart');
        if (fresh && current && current.parentNode) current.parentNode.replaceChild(fresh, current);
        var settingsNode = tmp.querySelector('[data-section-type="cart-template"]');
        if (settingsNode && settingsNode.getAttribute('data-section-settings')) {
          drawer.setAttribute('data-section-settings', settingsNode.getAttribute('data-section-settings'));
        }
        return openPursuitDrawer();
      })
      .catch(function () { return openPursuitDrawer(); });
  }

  function addToCart(body, isFormData) {
    var opts = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (isFormData) { opts.body = body; }
    else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(CFG.routes.cartAdd + '.js', opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || CFG.strings.error || 'Error'); return j; });
    });
  }

  /* after a successful add: count, drawer (if Pursuit's exists) or inline confirmation */
  function afterAdd(inlineEl) {
    updateCartCount();
    if (document.getElementById('sidebar-cart')) {
      refreshAndOpenDrawer();
      if (inlineEl) inlineEl.hidden = true;
    } else if (inlineEl) {
      inlineEl.hidden = false;
      clearTimeout(inlineEl.__t);
      inlineEl.__t = setTimeout(function () { inlineEl.hidden = true; }, 6000);
    }
  }

  /* ---------- cart: Gutschein/Rabattcode-Feld (ki-cart-extras, part: 'discount') ----------
   * Storefront has no AJAX endpoint to apply a code to the existing cart; the vanilla-theme approach is a full
   * navigation to /discount/{code}?redirect=/cart, which applies the code via a session cookie and redirects back.
   * The block is a <div data-ki-discount-form> (NOT a <form>): drawer and cart page already render it inside
   * Pursuit's own <form class="Cart">, and a nested <form> is invalid HTML - browsers silently drop it (and its
   * class), which broke the layout. So this binds a plain button click plus Enter in the input instead of 'submit'.
   * Delegated on document (not per-element bind via boot()) because the drawer's markup is replaced wholesale on
   * every add-to-cart (refreshAndOpenDrawer() swaps .Cart), so a listener bound once would go stale after refresh. */
  function applyDiscountFrom(wrap) {
    var input = $('[data-ki-discount-input]', wrap) || $('input', wrap);
    var code = input ? input.value.trim() : '';
    if (!code) { if (input) input.focus(); return; }
    var root = (window.routes && window.routes.rootUrl) || CFG.routes.cart.replace(/cart\/?$/, '') || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var cartUrl = (window.routes && window.routes.cartUrl) || CFG.routes.cart || '/cart';
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ki-discount-submit]');
    if (!btn) return;
    var wrap = btn.closest('[data-ki-discount-form]');
    if (!wrap) return;
    e.preventDefault();
    applyDiscountFrom(wrap);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-ki-discount-input]');
    if (!input) return;
    var wrap = input.closest('[data-ki-discount-form]');
    if (!wrap) return;
    e.preventDefault();
    applyDiscountFrom(wrap);
  });

  /* ---------- header: navigation for long menus ----------
   * - dropdown per top-level item with children: hover (fine pointer, desktop) + click/Enter on the toggle button,
   *   aria-expanded/aria-controls, Escape closes and returns focus, focus leaving the item closes it
   * - Priority+ overflow (nav_layout "single", desktop): top-level items that don't fit move into the trailing
   *   „Mehr" dropdown (their children render as an indented group via CSS); restored when space returns.
   *   Measuring happens synchronously (restore → measure → move) so no intermediate frame is painted.
   * - nav_layout "two-rows" and mobile (≤960px): no overflow, all items stay in place (accordion on mobile)
   */
  function childBy(el, sel) {
    var kids = el.children;
    for (var i = 0; i < kids.length; i++) { if (kids[i].matches(sel)) return kids[i]; }
    return null;
  }
  function initNav(header) {
    var nav = $('[data-ki-nav]', header);
    if (!nav || nav.__kiNav) return;
    nav.__kiNav = true;
    var list = $('[data-ki-nav-list]', nav);
    var more = $('[data-ki-nav-more]', nav);
    var moreList = more ? $('[data-ki-more-list]', more) : null;
    var layout = header.getAttribute('data-ki-nav-layout') || 'single';
    var items = $$('[data-ki-nav-item]', list).filter(function (li) { return li.parentNode === list; });
    var mqDesktop = window.matchMedia('(min-width: 961px)');
    var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    /* --- open / close --- */
    function toggleOf(li) { var row = childBy(li, '.ni-row'); return row ? childBy(row, '[data-ki-sub-toggle]') : null; }
    function setOpen(li, open) {
      if (!li) return;
      var btn = toggleOf(li);
      if (open) { closeAll(li); }
      li.classList.toggle('open', open);
      if (btn) btn.setAttribute('aria-expanded', String(open));
      if (open && mqDesktop.matches) {
        var sub = childBy(li, '[data-ki-sub]');
        if (sub) {
          sub.classList.remove('sub-right');
          var r = sub.getBoundingClientRect();
          if (r.right > document.documentElement.clientWidth - 8) sub.classList.add('sub-right');
        }
      }
    }
    function closeAll(except) {
      $$('.ni.open', nav).forEach(function (li) {
        if (li === except || (except && li.contains(except))) return;
        setOpen(li, false);
      });
    }
    function inMore(li) { return !!(moreList && moreList.contains(li)); }

    $$('[data-ki-sub-toggle]', nav).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var li = btn.closest('.ni');
        setOpen(li, !li.classList.contains('open'));
      });
    });
    /* hover intent (desktop, real pointer only) */
    $$('.ni.has-sub', nav).forEach(function (li) {
      var t;
      li.addEventListener('mouseenter', function () {
        if (!mqHover.matches || !mqDesktop.matches || inMore(li)) return;
        clearTimeout(t); t = setTimeout(function () { setOpen(li, true); }, 60);
      });
      li.addEventListener('mouseleave', function () {
        if (!mqHover.matches || !mqDesktop.matches || inMore(li)) return;
        clearTimeout(t); t = setTimeout(function () { setOpen(li, false); }, 160);
      });
    });
    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = $$('.ni.open', nav);
      if (!open.length) return;
      e.preventDefault(); e.stopPropagation();
      var li = open[open.length - 1];
      setOpen(li, false);
      var btn = toggleOf(li); if (btn) btn.focus();
    });
    nav.addEventListener('focusout', function () {
      setTimeout(function () {
        var a = document.activeElement;
        $$('.ni.open', nav).forEach(function (li) { if (!li.contains(a)) setOpen(li, false); });
      }, 0);
    });
    document.addEventListener('click', function (e) { if (!nav.contains(e.target)) closeAll(null); });

    /* --- Priority+ overflow --- */
    if (!more || !moreList) { nav.classList.add('nav-ready'); return; }
    var moreW = 0, lastAvail = -1;
    function measureMore() {
      var wasHidden = more.hidden;
      more.hidden = false; more.style.visibility = 'hidden'; more.style.position = 'absolute';
      moreW = more.offsetWidth;
      more.style.visibility = ''; more.style.position = ''; more.hidden = wasHidden;
    }
    function restoreAll() {
      items.forEach(function (li) { list.insertBefore(li, more); });
      closeAll(null);
      more.hidden = true;
      moreList.classList.remove('cols-2', 'cols-3');
    }
    function fit(force) {
      if (layout !== 'single' || !mqDesktop.matches) { restoreAll(); lastAvail = -1; nav.classList.add('nav-ready'); return; }
      var avail = nav.clientWidth;
      if (!force && avail === lastAvail) return;
      lastAvail = avail;
      restoreAll();
      if (!moreW) measureMore();
      var widths = items.map(function (li) { return li.offsetWidth; });
      var total = widths.reduce(function (a, b) { return a + b; }, 0);
      if (total > avail) {
        var limit = avail - moreW, used = 0, cut = items.length;
        for (var i = 0; i < items.length; i++) { used += widths[i]; if (used > limit) { cut = i; break; } }
        for (var j = cut; j < items.length; j++) moreList.appendChild(items[j]);
        more.hidden = cut >= items.length;
        var count = $$('a', moreList).length;
        moreList.classList.toggle('cols-3', count > 36);
        moreList.classList.toggle('cols-2', count > 14 && count <= 36);
      }
      nav.classList.add('nav-ready');
    }
    fit(true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moreW = 0; fit(true); });
    var pending;
    function schedule() { cancelAnimationFrame(pending); pending = requestAnimationFrame(function () { fit(false); }); }
    if ('ResizeObserver' in window) { new ResizeObserver(schedule).observe(nav); }
    else { var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { fit(false); }, 120); }); }
    var onMq = function () { fit(true); };
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', onMq); else mqDesktop.addListener(onMq);
  }

  /* ---------- header: mobile nav + cart icon ---------- */
  function initHeader(root) {
    if (root.hasAttribute('data-ki-header')) initNav(root);
    $$('[data-ki-nav-toggle]', root).forEach(function (btn) {
      var wrap = btn.closest('.hd-in');
      var nav = document.getElementById(btn.getAttribute('aria-controls')) || $('.nav', wrap);
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(open));
        if (open && nav) { var first = nav.querySelector('a'); if (first) first.focus(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && wrap.classList.contains('open') && !$('.ni.open', wrap)) { wrap.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
      });
    });
    $$('[data-ki-cart-link]', root).forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!document.getElementById('sidebar-cart')) return; /* no drawer → normal navigation to /cart */
        e.preventDefault();
        e.stopPropagation(); /* Pursuit closes the drawer on any document click outside it */
        openPursuitDrawer();
      });
    });
  }

  /* ---------- countdown ---------- */
  function initCountdown(el) {
    var raw = (el.getAttribute('data-ki-countdown') || '').trim().replace(' ', 'T');
    var end = new Date(raw).getTime();
    if (isNaN(end)) return;
    var f = function (n) { return String(Math.max(0, n)).padStart(2, '0'); };
    var d = $('[data-ki-d]', el), h = $('[data-ki-h]', el), m = $('[data-ki-m]', el), s = $('[data-ki-s]', el);
    var timer;
    var tick = function () {
      var diff = Math.max(0, end - Date.now());
      if (d) d.textContent = f(Math.floor(diff / 864e5));
      if (h) h.textContent = f(Math.floor(diff / 36e5) % 24);
      if (m) m.textContent = f(Math.floor(diff / 6e4) % 60);
      if (s) s.textContent = f(Math.floor(diff / 1e3) % 60);
      if (diff === 0) clearInterval(timer);
    };
    tick(); timer = setInterval(tick, 1000);
  }

  /* ---------- tabs (WAI-ARIA tabs pattern, roving tabindex, arrow keys) ---------- */
  function initTabs(root) {
    var tabs = $$('[role="tab"]', root);
    var panels = $$('[role="tabpanel"]', root);
    if (!tabs.length) return;
    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) {
        var on = p.id === tab.getAttribute('aria-controls');
        p.classList.toggle('on', on);
        p.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t, false); });
      t.addEventListener('keydown', function (e) {
        var idx = i;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') idx = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') idx = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') idx = 0;
        else if (e.key === 'End') idx = tabs.length - 1;
        else return;
        e.preventDefault();
        activate(tabs[idx], true);
      });
    });
  }

  /* ---------- quick add on product cards ---------- */
  function initQuickAdd(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-ki-add-btn]', form) || $('button', form);
      var txt = $('[data-ki-add-text]', form) || btn;
      var orig = txt.textContent;
      btn.disabled = true; txt.textContent = CFG.strings.adding || '…';
      var idIn = $('[name="id"]', form);
      addToCart({ id: idIn.value, quantity: 1 })
        .then(function () {
          txt.textContent = '✓ ' + orig;
          afterAdd(null);
          setTimeout(function () { txt.textContent = orig; btn.disabled = false; }, 1400);
        })
        .catch(function () { btn.disabled = false; txt.textContent = orig; form.submit(); });
    });
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var section = root.closest('.shopify-section') || document;
    var dataEl = $('[data-ki-product-json]', section);
    if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var cfg = readConfig(section);
    var S = cfg.strings;
    var form = $('[data-ki-product-form]', root);
    var mainImg = $('[data-ki-main-image]', root);
    var thumbs = $$('[data-ki-thumb]', root);

    function showMedia(id) {
      var th = null;
      thumbs.forEach(function (t) { if (String(t.getAttribute('data-ki-media-id')) === String(id)) th = t; });
      if (!th || !mainImg) return;
      mainImg.src = th.getAttribute('data-ki-src');
      mainImg.srcset = th.getAttribute('data-ki-srcset') || '';
      if (th.getAttribute('data-ki-alt')) mainImg.alt = th.getAttribute('data-ki-alt');
      thumbs.forEach(function (t) {
        var on = t === th;
        t.classList.toggle('on', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-ki-media-id')); }); });

    /* quantity stepper */
    var qty = $('[data-ki-qty]', root);
    var minus = $('[data-ki-qty-minus]', root), plus = $('[data-ki-qty-plus]', root);
    if (qty && minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); qty.dispatchEvent(new Event('change')); });
    if (qty && plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; qty.dispatchEvent(new Event('change')); });
    if (qty) qty.addEventListener('change', function () { if (!(parseInt(qty.value, 10) > 0)) qty.value = 1; });

    /* variants */
    var optionInputs = $$('[data-ki-option-input]', root);
    var fieldsets = $$('fieldset[data-ki-option-index]', root);
    function selectedOptions() {
      return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function matchVariant(sel) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function findVariant() { return matchVariant(selectedOptions()); }

    var addBtn = $('[data-ki-add-btn]', root), addText = $('[data-ki-add-text]', root), idIn = $('[data-ki-variant-id]', root);
    var priceEl = $('[data-ki-price]', root), cmp = $('[data-ki-compare]', root), save = $('[data-ki-save]', root), badge = $('[data-ki-sale-badge]', root);
    var stock = $('[data-ki-stock]', root), unitEl = $('[data-ki-unit-price]', root);

    function setPrice(el, cents, label) {
      if (!el) return;
      el.textContent = '';
      if (label) { var vh = document.createElement('span'); vh.className = 'visually-hidden'; vh.textContent = label + ' '; el.appendChild(vh); }
      el.appendChild(document.createTextNode(money(cents, cfg.moneyFormat)));
    }

    function render(v) {
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = S.unavailable || 'Nicht verfügbar';
        return;
      }
      if (idIn) idIn.value = v.id;
      setPrice(priceEl, v.price, S.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !onSale; if (onSale) setPrice(cmp, v.compare_at_price, S.regularPrice); }
      var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      if (save) { save.hidden = !onSale; save.textContent = '−' + pct + '%'; }
      if (badge) { badge.hidden = !onSale; badge.textContent = '−' + pct + ' %'; }
      if (unitEl && v.unit_price && v.unit_price_measurement) {
        var ref = v.unit_price_measurement.reference_value === 1 ? '' : v.unit_price_measurement.reference_value;
        unitEl.textContent = money(v.unit_price, cfg.moneyFormat) + ' / ' + ref + v.unit_price_measurement.reference_unit;
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? (S.addToCart || 'In den Warenkorb') : (S.soldOut || 'Ausverkauft');
      if (stock) {
        var low = v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= cfg.lowStock;
        stock.classList.toggle('low', !v.available || !!low);
        var st = $('[data-ki-stock-text]', stock);
        if (st) st.textContent = !v.available ? stock.getAttribute('data-ki-out') : low ? stock.getAttribute('data-ki-low') : stock.getAttribute('data-ki-ok');
      }
      $$('[data-ki-sku]').forEach(function (el) { if (v.sku) el.textContent = v.sku; });
      if (v.featured_media) showMedia(v.featured_media.id);
      /* ?variant= in URL (SEO / sharing) */
      try { var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); } catch (e) {}
      /* chips: mark unavailable combinations */
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = selectedOptions(); test[idx] = inp.value;
          var match = matchVariant(test);
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (!lab) return;
          lab.classList.toggle('oos', !match || !match.available);
          lab.classList.toggle('on', inp.checked);
        });
      });
      root.dispatchEvent(new CustomEvent('ki:variantChange', { bubbles: true, detail: { variant: v } }));
    }
    optionInputs.forEach(function (i) { i.addEventListener('change', function () { render(findVariant()); }); });
    if (optionInputs.length) render(findVariant());

    /* AJAX add to cart */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = $('[data-ki-error]', root), added = $('[data-ki-added]', root);
      var orig = addText ? addText.textContent : '';
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = S.adding || '…';
      if (err) { err.textContent = ''; err.classList.remove('on'); }
      addToCart(new FormData(form), true)
        .then(function () {
          if (addText) addText.textContent = '✓ ' + orig;
          afterAdd(added);
          setTimeout(function () { if (addText) addText.textContent = orig; if (addBtn) addBtn.disabled = false; }, 1600);
        })
        .catch(function (ex) {
          if (err) { err.textContent = ex.message || S.error || 'Fehler'; err.classList.add('on'); }
          if (addText) addText.textContent = orig;
          if (addBtn) addBtn.disabled = false;
        });
    });
  }

  /* ---------- product recommendations (Section Rendering API) ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-ki-url');
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ki-recommendations]');
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
          $$('[data-ki-quick-add]', el).forEach(initQuickAdd);
        }
      })
      .catch(function () {});
  }

  /* ---------- collection: „Mehr lesen“ (Intro) ---------- */
  function initReadMore(box) {
    var btn = $('[data-ki-readmore-btn]', box), full = $('[data-ki-readmore-full]', box), short = $('[data-ki-readmore-short]', box), label = $('[data-ki-readmore-label]', box);
    if (!btn || !full) return;
    function set(open) {
      full.hidden = !open;
      if (short) short.hidden = open;
      if (open) box.removeAttribute('data-ki-collapsed'); else box.setAttribute('data-ki-collapsed', '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? (btn.getAttribute('data-ki-less') || 'Weniger anzeigen') : (btn.getAttribute('data-ki-more') || 'Mehr lesen');
    }
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      set(open);
      if (open) { full.setAttribute('tabindex', '-1'); full.focus({ preventScroll: true }); }
      else { btn.focus(); }
    });
  }

  /* ---------- collection: Filter, Sortierung, Pagination (Section Rendering API) ----------
   * - form auto-submits on change (checkboxes immediately, price inputs debounced) → fetch `url&section_id=…`,
   *   replace the section's innerHTML, history.pushState; back/forward re-fetch (popstate)
   * - pagination links, active-filter chips and reset links are intercepted the same way
   * - mobile (≤960px) / top layout: panel opens as drawer/dropdown (Esc closes, focus returned, body.ki-filters-open lock)
   * - without JS: normal GET navigation (form method=get, real links)
   */
  var colState = { bound: false };
  function initCollection(root) {
    root.classList.add('js');
    var sectionId = root.getAttribute('data-ki-section-id');
    var form = $('[data-ki-filter-form]', root);
    var sort = $('[data-ki-sort]', root);
    var openBtn = $('[data-ki-filter-open]', root);
    var panel = $('[data-ki-filter-panel]', root);
    var loading = $('[data-ki-loading]', root);
    var mq = window.matchMedia('(max-width:960px)');
    var isTop = root.classList.contains('lay-top');
    var timer, ctrl, lastFocusSel = null;

    function wrapper() { return document.getElementById('shopify-section-' + sectionId) || root.parentNode; }

    function buildUrl() {
      var base = root.getAttribute('data-ki-collection-url') || location.pathname;
      var params = new URLSearchParams();
      if (form) {
        var fd = new FormData(form);
        fd.forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
      }
      if (sort && sort.value && !params.has('sort_by')) params.set('sort_by', sort.value);
      var q = params.toString();
      return base + (q ? '?' + q : '');
    }

    function load(url, opts) {
      opts = opts || {};
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      root.setAttribute('aria-busy', 'true');
      if (loading) loading.hidden = false;
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      return fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ki-collection]');
          var wrap = wrapper();
          if (!fresh || !wrap) { location.href = url; return; }
          var wasOpen = root.classList.contains('filters-open');
          var openDetails = $$('details.col-f', root).map(function (d) { return d.open; });
          wrap.innerHTML = '';
          wrap.appendChild(fresh);
          if (!opts.noPush) history.pushState({ kiCollection: sectionId }, '', url);
          /* re-init on the new root */
          fresh.__kiBooted = true;
          var newRoot = fresh;
          $$('[data-ki-quick-add]', newRoot).forEach(initQuickAdd);
          initCollection(newRoot);
          $$('details.col-f', newRoot).forEach(function (d, i) { if (typeof openDetails[i] === 'boolean') d.open = openDetails[i]; });
          if (wasOpen) newRoot.__kiOpenFilters(false);
          /* focus management */
          if (lastFocusSel) {
            var again = $(lastFocusSel, newRoot);
            if (again) { again.focus({ preventScroll: true }); }
            lastFocusSel = null;
          } else if (opts.focusGrid) {
            var main = $('.col-main', newRoot);
            if (main) { main.focus({ preventScroll: true }); }
          }
          if (opts.scroll) {
            var top = newRoot.getBoundingClientRect().top + window.pageYOffset - 90;
            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          }
          var status = $('.col-result', newRoot);
          if (status) { var t = status.textContent; status.textContent = ''; setTimeout(function () { status.textContent = t; }, 30); }
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          location.href = url;
        });
    }

    function submit(focusSel) {
      lastFocusSel = focusSel || null;
      load(buildUrl(), { scroll: false });
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); submit(); if (mq.matches || isTop) openFilters(false); });
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.name) return;
        if (t.type === 'number') { clearTimeout(timer); timer = setTimeout(function () { submit('#' + t.id); }, 500); return; }
        submit(t.id ? '#' + t.id : null);
      });
      form.addEventListener('input', function (e) {
        var t = e.target;
        if (t && t.type === 'number') { clearTimeout(timer); timer = setTimeout(function () { submit('#' + t.id); }, 700); }
      });
    }
    if (sort) sort.addEventListener('change', function () { submit('[data-ki-sort]'); });

    /* chips / reset / pagination links */
    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[data-ki-filter-link], [data-ki-pagination] a[href]') : null;
      if (!a || !root.contains(a)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      var isPager = !!a.closest('[data-ki-pagination]');
      lastFocusSel = null;
      load(a.getAttribute('href'), { scroll: isPager, focusGrid: isPager });
    });

    /* drawer / dropdown */
    function openFilters(open) {
      if (!panel || !openBtn) return;
      root.classList.toggle('filters-open', open);
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (mq.matches) document.body.classList.toggle('ki-filters-open', open);
      if (open) {
        var first = $('[data-ki-filter-close]', panel) || panel;
        if (mq.matches && first && first.focus) first.focus();
        else { var f = $('input, button, summary', panel); if (f) f.focus({ preventScroll: true }); }
      } else {
        document.body.classList.remove('ki-filters-open');
      }
    }
    root.__kiOpenFilters = openFilters;
    if (openBtn) openBtn.addEventListener('click', function () { var open = openBtn.getAttribute('aria-expanded') !== 'true'; openFilters(open); if (!open) openBtn.focus(); });
    $$('[data-ki-filter-close]', root).forEach(function (b) { b.addEventListener('click', function () { openFilters(false); if (openBtn) openBtn.focus(); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('filters-open')) { e.preventDefault(); openFilters(false); if (openBtn) openBtn.focus(); }
    });
    var onMq = function () { if (!mq.matches) document.body.classList.remove('ki-filters-open'); if (!mq.matches && !isTop) openFilters(false); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);

    /* back / forward */
    if (!colState.bound) {
      colState.bound = true;
      window.addEventListener('popstate', function () {
        var cur = $('[data-ki-collection]');
        if (!cur) return;
        var fn = cur.__kiLoad;
        if (fn) fn(location.pathname + location.search, { noPush: true, scroll: false });
      });
    }
    root.__kiLoad = load;
  }

  /* ---------- boot: everything scoped to .ki roots ---------- */
  function boot(scope) {
    scope = scope || document;
    $$('.ki', scope).forEach(function (root) {
      if (root.__kiBooted) return;
      root.__kiBooted = true;
      initHeader(root);
      $$('[data-ki-countdown]', root).forEach(initCountdown);
      $$('[data-ki-tabs]', root).forEach(initTabs);
      $$('[data-ki-quick-add]', root).forEach(initQuickAdd);
      $$('[data-ki-product]', root).forEach(initProduct);
      $$('[data-ki-readmore]', root).forEach(initReadMore);
      if (root.hasAttribute('data-ki-collection')) initCollection(root);
      if (root.hasAttribute('data-ki-recommendations')) initRecommendations(root);
      $$('[data-ki-recommendations]', root).forEach(initRecommendations);
    });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { boot(document); });

  /* Theme editor: re-init re-rendered sections */
  document.addEventListener('shopify:section:load', function (e) {
    $$('.ki', e.target).forEach(function (r) { r.__kiBooted = false; });
    boot(e.target);
  });

  window.KI = { __booted: true, money: money, initCollection: initCollection, updateCartCount: updateCartCount, openDrawer: openPursuitDrawer, refreshAndOpenDrawer: refreshAndOpenDrawer, boot: boot };
})();
